import {Validators} from '@angular/forms';
import {isCorrectTime} from "../validators/time.validator";
import {isCorrectDuration} from "../validators/duration.validator";

/** */
export function sectorGroup( fb: any ): any {
    return fb.array([sectorGroupInArray(fb)]);
}

export function sectorGroupInArray(fb: any): any {
    return fb.group({
        id: fb.control(''),
        index: fb.control(''),
        begin: fb.group({
            date: fb.control('', [Validators.required]),
            offset: fb.group({
                day: fb.control(''),
                origin: fb.control('journey')
            })
        }),
        end: fb.group({
            offset: fb.group({
                day: fb.control(0),
                origin: fb.control('sector')
            })
        }),
        from: fb.control('', Validators.required),
        to: fb.control('', Validators.required),
        flight: fb.control(''),
        carrier: fb.control('', Validators.required),
        seat: fb.control(''),
        isReturnBegin: fb.control(false),
        schedule: fb.group({
            data: fb.control(''),
            begin: fb.control('', isCorrectTime('schedule.begin')),
            end: fb.control('', isCorrectTime('schedule.end')),
            duration: fb.control('', isCorrectDuration())
        })
    });
}
